import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import PropTypes from 'prop-types'

const CustomSelect = ({ placeholder, inputPlaceholder, required = false, ...props }) => {
  const { t } = useTranslation()
  const hasFloatingLabel = String(placeholder || '').trim().length > 0
  const baseStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    placeholder: (provided) => ({
      ...provided,
      color: '#78909C',
      fontSize: '14px'
    })
  }
  const customStyles = {
    ...baseStyles,
    ...(props.styles || {})
  }

  return (
    <div className='relative z-11'>
      {hasFloatingLabel && (
        <label data-disabled={Boolean(props?.isDisabled)} className='data-[disabled=true]:bg-transparent absolute -top-2 left-2 px-1 pl-1 z-10 bg-white text-blue-gray-400 font-light text-[11px]'>
          {required ? <span>{placeholder} <span className='text-red-500'>*</span></span> : placeholder}
        </label>
      )}
      <Select
        placeholder={inputPlaceholder || t('select.one')}
        {...props}
        styles={customStyles}
        menuPortalTarget={document.body}
      />
    </div>
  )
}

export default CustomSelect

CustomSelect.propTypes = {
  placeholder: PropTypes.string,
  inputPlaceholder: PropTypes.string,
  required: PropTypes.bool,
  styles: PropTypes.object,
  isDisabled: PropTypes.bool
}
